import { Button } from 'components/common';

import type { ButtonInterface } from './Button';

interface LinkButtonInterface extends ButtonInterface {
  external?: boolean;
  href: string;
  openInNewTab?: boolean;
}

const LinkButton = ({
  category,
  external,
  href,
  icon,
  iconStyle,
  openInNewTab,
  size,
  style,
  text,
  tooltip,
  ...props
}: LinkButtonInterface) => {
  return (
    <Button
      category={category}
      className="link focus-box-shadow"
      href={props.disabled ? undefined : href}
      icon={icon}
      iconStyle={iconStyle}
      size={size}
      style={style}
      text={text}
      tooltip={tooltip}
      {...(openInNewTab
        ? {
            rel: 'noopener noreferrer',
            target: '_blank'
          }
        : {})}
      {...props}
    />
  );
};

export default LinkButton;
